module.exports = __webpack_public_path__ + "media/images/forms-icons/separator-icon-hover-1be5b0a092a403552b6a112caad9877b.svg";